<template>
  <div class="scenicParkDetail">
    <loading v-if="isLoading"></loading>
    <div v-else>
      <div v-if="!isPageError">
        <div class="banner_container">
          <van-image width="100%" :height="234" :src="detailData.headImg"></van-image>
        </div>
        <div class="desc_container">
          <div class="desc_box">
            <div class="desc_left">
              <div class="desc_title">{{detailData.title}}</div>
            </div>
            <div class="desc_right">
              <div class="right_top">
                <div class="right_collect" @click="postCollect">
                  <img :src="collectObj.is_collect?(require('../../assets/img/likeAfterIcon.png')):(require('../../assets/img/collectBefore_icon.png'))" alt="">
                </div>
                <div class="right_collect_text" v-if="Number(collectObj.count) > 0" :style="{color:collectObj.is_collect?'#FF504D':'#262626'}">
                  {{Number(collectObj.count)>=10000?(Number(collectObj.count)/10000).toFixed(1)+'w':Number(collectObj.count) >= 1000?(Number(collectObj.count)/1000).toFixed(1)+'k':Number(collectObj.count)}}
                </div>
              </div>
            </div>
          </div>
          <div class="desc_bottom">
            <!-- <div class="desc_bottom_title">用时参考2-3小时</div> -->
            <div class="desc_label_box">
              <div class="desc_label" v-for="(item,index) in detailData.tags" :key="index">{{item}}</div>
            </div>
          </div>
        </div>

        <div class="intro_container">
          <div class="intro_title">攻略详情</div>
          <div class="intro_innerText" @click="clickElementVHTML" v-html="detailData.htmlContent"></div>
        </div>

        <div class="innerText_list_box" v-if="detailData.scenicInfo">
          <div class="innerText_title">文中提及</div>
          <div class="innerText_list">
            <div class="innerText_item" @click="toScenicDetail(detailData.scenicInfo)">
              <div class="item_left">
                <img :src="detailData.scenicInfo.imageList[0]" alt="">
                <div class="item_middle">
                  <div class="item_title">{{detailData.scenicInfo.name}}</div>
                  <div class="item_distance" v-if="isShowDistance">距你{{distance(detailData.scenicInfo.latitude,detailData.scenicInfo.longitude)}}</div>
                  <!-- <div class="item_distance">实时人数:{{detailData.scenicInfo.personCount}}</div> -->
                  <div class="labels">
                    <div class="label" v-for="(item,index) in detailData.scenicInfo.tags" :key="index">{{item}}</div>
                  </div>
                </div>
              </div>
              <div class="item_right">
                <div v-if="(detailData.scenicInfo.audio.voiceMan && detailData.scenicInfo.audio.voiceMan!=='[]') || (detailData.scenicInfo.audio.voiceWoman && detailData.scenicInfo.audio.voiceWoman !=='[]')" class="right_item right_item_first" @click.stop="palyAudio(detailData.scenicInfo)">
                  <img src="../../assets/img/gray_say.png" alt="">
                  <div>讲解</div>
                </div>
                <div v-else class="right_item right_item_first" :style="{visibility:'hidden'}">
                  <img src="../../assets/img/gray_say.png" alt="">
                  <div>讲解</div>
                </div>
                <div class="right_item" @click.stop="goToLocation(detailData.scenicInfo)">
                  <img src="../../assets/img/goHere_icon.png" alt="">
                  <div>去这里</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 用户评论 -->
        <div class="comment-box">
          <van-cell title="精彩点评" v-if="CommentNum>0" is-link :value="'全部 '+CommentNum + ' 条点评'" @click="AllDiscussList()" />
          <van-cell title="精彩点评" v-else />
          <div class="comment-list" v-if="CommentNum !== 0">
            <customListView :arraydata="commentList" @itemDianZan="itemDianZan" @itemClick="Details" @bigPictureLook="BigPictureLook" @itemReply="itemReply">
            </customListView>
          </div>
          <div class="list-no" v-if="CommentNum === 0">
            <p>来发表第一条评论吧~</p>
          </div>
          <div class="btn">
            <van-button color="#2EBA73" @click="Write()">
              写点评
            </van-button>
          </div>
        </div>

        <div>
          <writeComment :isUploadIconShow="isShowImageIcon" ref="writeComment" @Fb="Fb(arguments)" id="modalId"></writeComment>
        </div>

        <div>
          <displayimage ref="displayimage"></displayimage>
        </div>
        <!-- 用户评论 end -->

        <!-- 猜你喜欢 -->
        <div class="recommend_container" v-if="aroundData.length > 0 && count < 2">
          <div class="recommend_title">
            <div class="title_left">猜你喜欢</div>
          </div>
          <div class="best_container">
            <!-- <swiper :options="{slidesPerView: 2.3, spaceBetween: 0,slidesOffsetAfter: 20}" ref="mySwiper"> -->
            <div class="best_item" v-for="(item,index) in aroundData" :key="index">
              <div @click="toDetail(item)" v-if="index == 0" :style="{paddingBottom:'20px'}">
                <div class="item_left">
                  <van-image radius="3px" width="100%" :height="160" lazy-load :src="item.cover_img" />
                </div>
                <div class="item_right">
                  <div class="title item_title">{{item.name}}</div>
                  <div class="label_box" v-if="item.tags">
                    <div class="label" v-for="(item,index) in item.tags" :key="index">{{item}}</div>
                  </div>
                  <div class="distance">
                    <span class="location">{{item.strategyScenicName}}</span>
                    <!-- <span class="distance">距你{{distance(item.latitude,item.longitude)}}</span> -->
                  </div>
                  <!-- <div class="distance">
                      <span class="location">{{Number(item.strategyLikeCount)}}人收藏&nbsp;&nbsp;</span>
                      <span class="distance">{{Number(item.strategyCommentCount)}}条评论</span>
                    </div> -->
                </div>
              </div>
            </div>
            <!-- </swiper> -->

          </div>
        </div>
        <!-- 猜你喜欢 end -->
      </div>
      <page-error v-else></page-error>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
// import { Empty } from 'vant';
import LeftImg from '@/components/LeftImgRightText';
import PageError from '../../components/PageError';
import Loading from '@/components/loading';
import { getDistance } from '../../common/common';
import TabCheckout from '@/components/TabCheckout';
import writeComment from "@/components/writeComment.vue";
import customListView from "@/components/customListViewComment.vue";
import displayimage from "@/components/displayImage.vue";
import axios from 'axios'

// Vue.use(Empty);
export default {
  name: "line_list",
  data() {
    return {
      isPageError: false,
      isLoading: true,
      // 图片数组
      imgList: [],
      CommentNum: 0, // 评论条数
      commentList: [],

      scenicId: '',
      imgIndex: 0,
      detailData: {},
      //附近推荐
      aroundTabArray: [],
      aroundData: [],
      allATbArr: [],
      aroundTabActive: 0,
      // 收藏数据对象
      collectObj: {
        count: 0
      },
      // 当前选择的audio对象 用于音频切换传参
      currentAudio: {},
      isShowDistance: false,
      // 全局音频组件所在vue实例对象 (App.vue)
      App: this.$root.$children[0],
      count: 0,
      isShowImageIcon: true,
      vImageArr: [], // 富文本图片数组列表
      collectLoading:false,//收藏是否正在加载中
    };
  },
  components: {
    // LeftImg,
    Loading,
    PageError,
    // TabCheckout,
    writeComment,
    customListView,
    displayimage
  },
  watch: {
    $route(to, from) {
      this.isLoading = true;
      window.location.reload();
    }
  },
  mounted() {
    this.uid = this.$cookie.get('w_uid') || '';
    this.scenicId = this.$route.query.id;
    this.isShowDistance = Boolean(sessionStorage.getItem('isShowDistance'));
    this.count = this.$route.query.count ? this.$route.query.count : 0;
    this.getCommentList();
    this.getlineDetail();
    this.getRecommend();
    this.getCollectNum();
  },
  methods: {

    clickElementVHTML(e) {
      console.log(e.target.src, 'eeeeee');
      if (e.target.nodeName == 'img' || e.target.nodeName == 'IMG') {
        console.log('是图片');
        console.log(this.vImageArr,'this.vImageArr');
        wx.ready(() => {
          wx.previewImage({
            current: e.target.src.trim(), // 当前显示图片的http链接
            urls: this.vImageArr // 需要预览的图片http链接列表
          });
        })

      }
    },

    /**
     * 初始化分享事件
     */
    shareInit() {
      console.log('初始化')
      wx.ready(() => {
        // eslint-disable-next-line
        //需在用户可能点击分享按钮前就先调用
        wx.updateAppMessageShareData({
          title: this.detailData.title, // 分享标题
          desc: this.detailData.content, // 分享描述
          link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.detailData.headImg, // 分享图标
          success: function () {
            // 分享成功
          },
        });
        wx.updateTimelineShareData({
          title: this.detailData.title, // 分享标题
          link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.detailData.headImg,
          success: function () {
            // 分享成功
          },
        });
      });
      wx.error(function (res) {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        alert('error: ' + res);
      });
    },

    /**
     * 去详情
     */
    toDetail(item) {
      let count = this.$route.query.count ? this.$route.query.count : 0;
      if (count < 2) {
        this.$router.push({
          path: '/strategyDetails',
          query: {
            id: item.id,
            lat: this.$route.query.lat,
            lng: this.$route.query.lng,
            count: Number(count) + 1
          },
        });
      }

    },

    /**
     * 文中提及点击跳转事件
     */
    toScenicDetail(item) {
      console.log(item, 'itemitemitemitme');
      this.$router.push({
        name: 'scenicParkDetail',
        query: {
          id: item.scenicId
        },
      });

    },

    /**
     * 去导航
     */
    goToLocation(item) {
      item.address = item.address ? item.address : ' ';
      this.openLocation(item.latitude, item.longitude, item.name, item.address);
    },

    /**
     * 获取猜你喜欢数据
     */
    getRecommend() {
      let data = new FormData();
      data.append('srcType', 'strategy');
      data.append('srcId', this.scenicId);
      this.$request.post(`/appserver/v1/recommend/ld_detail_recommend`, data).then((res) => {
        if (res.data.ret == 0) {
          this.aroundData = res.data.data;
        } else {
          this.$toast('获取猜你喜欢失败');
        }
      }).catch((e) => { });
    },

    /**
     * 获取收藏数量/收藏状态
     */
    getCollectNum() {
      this.$request.get(`/appserver/v1/collect/is/collect?srcType=strategy&srcId=${this.scenicId}`).then((res) => {
        if (res.data.ret == 0) {
          let resData = res.data.data;
          this.collectObj = resData;
        }
      }).catch((e) => { });
    },

    /**
     * 提交收藏
     */
    postCollect() {
      if(this.collectLoading){
        return false;
      }
      this.collectLoading = true;
      // 未登录情况
      if (!this.$cookie.get('w_uid')) {
        if (this.$cookie.get('w_uid') == 0 && window.location.href.includes("state=wxAuth2")) {  // 登录了未绑定手机号
          this.$router.push({
            name: 'bindingPhone',
            query: {
              for: 'other'
            }
          })
        } else {  // 未登录
          this.wxAuth('wxAuth2');
        }
        return;
      }
      let data = new FormData();
      data.append('srcType', 'strategy');
      data.append('srcId', this.scenicId);
      if (this.collectObj.is_collect) {
        this.$request.post(`/appserver/v1/collect/cancel`, data).then((res) => {
          if (res.data.ret == 0) {
            this.$toast('取消收藏!');
            this.collectObj.is_collect = 0;
            this.collectObj.count = Number(this.collectObj.count) - 1;
            this.collectLoading = false;
          } else {
            this.$toast(res.data.msg);
            this.collectLoading = false;
          }
        }).catch((e) => { });
      } else {
        this.$request.post(`/appserver/v1/collect/save`, data).then((res) => {
          if (res.data.ret == 0) {
            this.$toast('收藏成功!');
            this.collectObj.is_collect = 1;
            this.collectObj.count = Number(this.collectObj.count) + 1;
            this.collectLoading = false;
          } else {
            this.$toast(res.data.msg);
            this.collectLoading = false;
          }
        }).catch((e) => { });
      }

    },

    /**
    * 附近推荐 tab切换
    */
    aroundTabCheckout(data) {
      this.aroundTabActive = data.index;
      this.aroundData = this.allATbArr[data.index];
    },

    swiperChange(type, event) {
      this.imgIndex = event;
    },

    /**
     * 控制视频播放/暂停
     */
    videoPlay(event) {
      if (event.target.paused) {
        event.target.play();
      } else {
        event.target.pause();
      }
    },

    /**
     * 播放语音
     */
    palyAudio(item) {
      this.App.audioWoMan = item.audio.voiceWoman == '[]' ? '' : item.audio.voiceWoman;
      this.App.audioMan = item.audio.voiceMan == '[]' ? '' : item.audio.voiceMan;
      this.App.audioTitle = item.name;
      this.App.palyAudio();
    },
    /**
     * 获取攻略详情数据
     */
    getlineDetail() {
      axios.create({
        baseURL: this.newUrlHost,
        headers: {},
        withCredentials: true,
      }).get(`/appserver/v1/strategy?id=${this.scenicId}`).then((res) => {
        if (res.data.ret == 0) {
          let resData = res.data.data;
          this.isLoading = false;
          this.detailData = resData;
          // this.detailData.htmlContent = this.detailData.htmlContent + "<video src='blob:https://tv.sohu.com/3c8d3782-61e8-449f-8c50-06e0badbacd5'></video>";
          /* eslint-disable */
          let imgUrls = this.detailData.htmlContent.match(/<img\b.*?(?:\>|\/>)/gi);
          for (let k in imgUrls) {
            /* eslint-disable */
            this.vImageArr.push(imgUrls[k].match(/\bsrc\b\s*=\s*[\'\"]?([^\'\"]*)[\'\"]?/i)[1]);
          }
          this.$nextTick(() => {   // 获取全部video 并且添加属性
            let targets = document.querySelectorAll('.intro_innerText video');
            let p_targets = document.querySelectorAll('.intro_innerText .video-wrapper');
            let videoWidth = [];
            let videoHeight = [];
            let promiseArr = [];
            for (let k in targets) {
              if ((typeof targets[k]) == 'object') {
                console.log(targets[k], 'targets[k]')
                targets[k].setAttribute('playsinline', '');
                targets[k].setAttribute("webkit-playsinline", "true");
                targets[k].setAttribute('x5-video-player-type', 'h5-page');
                targets[k].setAttribute('poster',  `${require('@/assets/img/video_default.png')}`);
                targets[k].setAttribute("preload", 'none');
                targets[k].setAttribute('controlsList', 'nodownload noremoteplayback');
                targets[k].setAttribute('disablePictureInPicture', '');
                p_targets[k].style = '';
              }
            }
          })
          /* eslint-disable */
          // let videos = this.detailData.htmlContent.match(/<video\b.*?(?:\>|\/>)/gi);
          // for(let k in videos){
          //   let split = videos[k].split(' ');
          //   console.log(split,'split');
          // }
          // console.log(videos, 'videos')
          setTimeout(() => {
            this.shareInit();
          }, 300)
        } else {
          if (res.data.errorcode == 500) { // 景区已下线
            this.$router.replace({
              name: '404'
            })
          } else {
            this.isLoading = false;
            this.isPageError = true;
          }
        }
      }).catch((e) => {
        console.log(e);
        this.isLoading = false;
        this.isPageError = true;
      });
    },

    /**
       * 跳转至导航页
       */
    toMap(lat, lng, location, address) {
      address = address ? address : ' ';
      this.openLocation(lat, lng, location, address);
    },

    /**
    * 计算距离你多少距离
    * @params lat lng 景区 景点 经纬度
    */
    distance(lat, lng) {
      if (this.$route.query.lat && this.$route.query.lng) {
        let obj = getDistance(lat, lng, this.$route.query.lat, this.$route.query.lng);
        return obj.distance.toFixed(1) + (obj.type == 'km' ? '公里' : '米');
      } else {
        // return { distance: '', text: '' };
        return '0米';
      }
    },
    /**
     * 获取评论
     */
    getCommentList() {
      let fromData = new FormData();
      console.log(this.scenicId, 'this.grenen')
      fromData.append("cid", this.scenicId);
      fromData.append("type", 'travel_notes');
      this.$request.post(`/appserver/v1/comment/list`, fromData)
        .then((data) => {
          let _data = data.data.data;
          if (_data.list.length !== 0) {
            this.commentList = _data.list;
          }
          this.CommentNum = _data.comment_num; // 评论条数
        });
    },

    /**
     * 用户点赞回调 
     */
    itemDianZan(item, commId) {
      if (!this.uid) {
        if (this.$cookie.get('w_uid') == 0 && window.location.href.includes("state=wxAuth2")) {  // 登录了未绑定手机号
          this.$router.push({
            name: 'bindingPhone',
            query: {
              for: 'other'
            }
          })
        } else {  // 未登录
          this.wxAuth('wxAuth2');
        }
        return;
      }
      let data = {
        comment_id: commId,
        number: "1",
      };
      let fromData = new FormData();
      fromData.append('comment_id', commId);
      fromData.append('number', 1);
      this.$request
        .post(`/appserver/v1/comment/deleteOrUp`, fromData, {
          headers: {
            uid: this.uid,
          },
        })
        .then((data) => {
          if (data.data.ret === 0) {
            item.up++;
            item.is_up = !item.is_up;
          } else {
            this.$toast(data.data.msg);
          }
        });
    },

    /**
     * 回复
     * @params item 回复的评论item commId  回复的commitId
     */
    itemReply(item, commId) {
      this.isShowImageIcon = false;
      this.parentId = commId;
      var u = navigator.userAgent;
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isIOS) {
        let windheight = document.documentElement.clientHeight; //为唤起软键盘时当前窗口高度
        document.getElementById("modalId").style.position = "relative";
        window.onresize = function () {
          var docheight = document.documentElement.clientHeight; //唤起软键盘时窗口高度
          document.getElementById("write").style.bottom =
            docheight - windheight + "px";
        };
      }
      if (this.uid) {
        this.$refs.writeComment.showWriteDialog();
      } else {
        if (this.$cookie.get('w_uid') == 0 && window.location.href.includes("state=wxAuth2")) {  // 登录了未绑定手机号
          this.$router.push({
            name: 'bindingPhone',
            query: {
              for: 'other'
            }
          })
        } else {  // 未登录
          this.wxAuth('wxAuth2');
        }
      }
    },

    // 用户评论列表
    AllDiscussList() {
      if (this.CommentNum <= 0) {
        return;
      } else {
        this.$router.push({
          path: "/allDiscussList",
          query: {
            cid: this.scenicId,
            type: "travel_notes",
          },
        });
      }
    },
    // 评论详情
    Details(item) {
      this.$router.push({
        path: "/discussDetails",
        query: {
          comment_id: item.comment_id,
          type: "travel_notes",
          from: "web",
        },
      });
    },
    // 图片点击放大
    BigPictureLook(item, index, dataItem) {
      let imageArr = [];
      for (let i = 0; i < item.length; i++) {
        if (item[i].checkRet == 1 && dataItem.uid != this.uid) { // 非法图片
          // imageArr.push('');
        } else {
          imageArr.push(item[i].data);
        }
      }
      this.$refs.displayimage.showBigPictureLook(imageArr, index);
    },
    // 写评论
    Write() {
      // 确保parentId为空，不是回复操作
      this.isShowImageIcon = true; // 显示上传图片
      this.parentId = null;
      var u = navigator.userAgent;
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isIOS) {
        let windheight = document.documentElement.clientHeight; //为唤起软键盘时当前窗口高度
        document.getElementById("modalId").style.position = "relative";
        window.onresize = function () {
          var docheight = document.documentElement.clientHeight; //唤起软键盘时窗口高度
          document.getElementById("write").style.bottom =
            docheight - windheight + "px";
        };
      }
      if (this.uid && this.uid != 0) {
        this.$refs.writeComment.showWriteDialog();
      } else {
        if (this.$cookie.get('w_uid') == 0 && window.location.href.includes("state=wxAuth2")) {  // 登录了未绑定手机号
          this.$router.push({
            name: 'bindingPhone',
            query: {
              for: 'other'
            }
          })
        } else {  // 未登录
          this.wxAuth('wxAuth2');
        }
      }
    },
    // 发表
    Fb(msg) {
      var message = msg[0];
      var gallerysStr = msg[1];
      let fromData = new FormData();
      fromData.append('content', message);
      fromData.append('cid', this.scenicId);
      fromData.append('ctitle', document.title);
      fromData.append('type', 'travel_notes');
      fromData.append('source_type', 'h5');
      fromData.append('image', gallerysStr);
      if (this.parentId) {
        fromData.append('parent_id', this.parentId);
      }
      this.$request
        .post(`/appserver/v1/comment/addComment`, (fromData), {
          headers: {
            uid: this.uid,
          },
        })
        .then((data) => {
          if (data.data.ret == 0) {
            if (this.parentId) {
              this.$toast("回复成功");
            } else {
              this.$toast("发布成功");
            }
            this.getCommentList();
            this.$refs.writeComment.ClosePost();
          } else {
            this.$refs.writeComment.ClosePost();
            if (data.data.msg == '缺少uid请登录' || data.data.msg == '用户id不能为空') {
              this.wxAuth();
            } else {
              this.$toast(data.data.msg);
            }
          }
        });
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.intro_innerText {
  /*video默认aduio音量按钮*/
  /deep/video::-webkit-media-controls-mute-button {
    display: none !important;
  }
  /*video默认setting按钮*/
  /deep/video::-internal-media-controls-overflow-button {
    display: none !important;
  }
  //音量按钮
  /deep/video::-webkit-media-controls-mute-button {
    display: none;
  }
  /deep/video::-webkit-media-controls-toggle-closed-captions-button {
    display: none;
  }
  //音量的控制条
  /deep/video::-webkit-media-controls-volume-slider {
    display: none;
  }

  /deep/.video-wrapper {
    position: relative;
    video {
      position: relative;
      z-index: 999;
      object-fit: fill;
    }
  }
  /deep/.video_shadow {
    position: absolute;
    background: rgba(0, 0, 0, 0.3);
    z-index: 99999999999;
    // transform: translateY(-50%);
    // height: 50px;
  }
}
.scenicParkDetail {
  .banner_container {
    position: relative;
    width: 100%;
    min-height: 234px;
    // background: gray;
    .video_ele {
      width: 100%;
      height: 234px;
      object-fit: fill;
    }
    .indicator_box {
      position: absolute;
      bottom: 20px;
      right: 20px;
      color: white;
      padding: 2px 8px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 10px;
    }
  }

  .desc_container {
    padding: 10px 20px 30px 20px;
    // padding-bottom: 0;
    border-bottom: 5px solid rgba(0, 0, 0, 0.05);
    .desc_box {
      display: flex;
      justify-content: space-between;
      .desc_left {
        padding-top: 20px;
      }
      .desc_right {
        .right_top {
          display: flex;
          align-items: stretch;
          img {
            width: 24px;
            height: 24px;
            vertical-align: top;
            margin-left: 20px;
          }
          .right_collect_text {
            font-size: 12px;
            color: rgba(0, 0, 0, 0.5);
            margin-left: 2px;
          }
        }
        .right_bottom {
          display: flex;
          .bottom_item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-left: 18px;
            margin-top: 10px;
            img {
              width: 32px;
              height: 32px;
              margin-bottom: 4px;
            }
            .item_text {
              font-size: 11px;
              color: rgba(0, 0, 0, 0.5);
            }
          }
        }
      }
    }
    .desc_title {
      font-size: 21px;
      color: #262626;
      font-weight: 700;
    }
    .desc_label_box {
      margin-top: 6px;
      .desc_label {
        padding: 2px 5px;
        background: rgba(97, 69, 247, 0.15);
        color: #6145f7;
        display: inline-block;
        margin-right: 5px;
        border-radius: 2px;
      }
    }
    .desc_bottom {
      //   padding: 30px 20px;
      .desc_bottom_title {
        margin-top: 6px;
        color: rgba(0, 0, 0, 0.5);
        font-size: 11px;
      }
    }
  }
  .recommend_container {
    margin-top: 40px;
    padding-left: 20px;
    padding-right: 20px;
    .recommend_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 20px;
      margin-bottom: 20px;
    }

    .title_left {
      font-size: 20px;
      font-weight: 400;
    }
    .best_container {
      .best_item {
        display: flex;
        flex-direction: column;
        // margin-bottom: 25px;
        // margin-right: 12px;
        .item_right {
          //   margin-left: 18px;
          margin-top: 12px;
          .title {
            font-size: 16px;
            color: #262626;
            font-weight: 700;
            margin-bottom: 8px;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
          .item_title {
            margin-bottom: 4px;
          }
          .distance {
            font-size: 11px;
            color: #787878;
            margin-bottom: 4px;
            .location {
              //   margin-left: 4px;
              color: #bfbfbf;
            }
          }
          .label_box {
            display: flex;
            margin-bottom: 4px;
            align-items: center;
            .label {
              padding: 0px 4px;
              background: rgba(97, 69, 247, 0.15);
              border-radius: 2px;
              color: #6145f7;
              margin-right: 4px;
            }
          }
        }
      }
    }
    .right_like {
      color: rgba(0, 0, 0, 0.5);
      font-size: 11px;
    }
    .tags_container {
      display: flex;
      flex-wrap: wrap;
      max-height: 20px;
      overflow: hidden;
      margin-bottom: 4px;
      .tags {
        margin-right: 3px;
        padding: 1px 3px;
        background: rgba(0, 0, 0, 0.05);
        color: #787878;
        font-size: 11px;
      }
    }
    .label_component {
      font-size: 11px;
      color: #2eba73;
      margin-top: 4px;
    }
    .strategy_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 20px;
      margin-bottom: 20px;
      .title_left {
        font-size: 20px;
        font-weight: 400;
      }
      .title_right {
        display: flex;
        align-items: center;
        span {
          margin-right: 10px;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.5);
        }
      }
      .title_tag {
        display: flex;
        align-items: center;
        white-space: nowrap;
        width: 100%;
        overflow-x: auto;
        ::-webkit-scrollbar {
          width: 0px;
        }
        .tag_item {
          margin-right: 30px;
          font-size: 16px;
          color: #787878;
          padding-bottom: 5px;
          cursor: pointer;
          width: initial;
        }
        .tag_item_active {
          font-size: 20px;
          color: #000000;
          position: relative;
          .item_line {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 20px;
            height: 4px;
            background: #2ed07e;
            border-radius: 2px;
          }
        }
      }
    }
    .strategy_title {
      padding-right: 0;
    }
    .tab_box {
      margin-bottom: 20px;
    }
    .label {
      font-size: 11px;
      color: rgba(0, 0, 0, 0.25);
      margin-top: 4px;
      display: flex;
      .label_item {
        background: rgba(97, 69, 247, 0.15);
        color: #6e5adb;
        margin-right: 4px;
        padding: 3px 4px;
        border-radius: 2px;
      }
    }
    .address {
      font-size: 11px;
      color: rgba(0, 0, 0, 0.25);
      margin-top: 4px;
    }
  }
  .intro_container {
    padding: 30px 20px;
    color: #262626;
    border-bottom: 5px solid rgba(0, 0, 0, 0.05);
    .intro_title {
      font-size: 20px;
      font-weight: 700;
    }
    .intro_innerText {
      font-size: 14px;
      color: #787878;
      margin-top: 10px;
      line-height: 20px;
      /deep/img {
        width: 100%;
      }
      /deep/video {
        width: 100%;
        object-fit: contain;
      }
    }
    .intro_innerText_hidden {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box; //将对象作为弹性伸缩盒子模型显示
      -webkit-line-clamp: 4; //控制显示几行文字
      -webkit-box-orient: vertical; //设置伸缩盒对象的子元素排列方式
    }
    .intro_fold {
      margin-top: 4px;
      font-size: 14px;
      color: #2eba73;
      display: flex;
      align-items: center;
      img {
        width: 11px;
        height: 7px;
        margin-left: 4px;
      }
    }
    .intro_map {
      width: 100%;
      height: 150px;
      margin-top: 20px;
    }
  }

  .innerText_list_box {
    padding: 30px 20px;
    .innerText_title {
      font-size: 20px;
      color: rgba(0, 0, 0, 0.85);
      margin-bottom: 20px;
    }
    .innerText_list {
      .innerText_item {
        display: flex;
        justify-content: space-between;
        .item_left {
          display: flex;
          img {
            width: 66px;
            height: 66px;
            border-radius: 3px;
          }
          .item_middle {
            display: flex;
            flex-direction: column;
            margin-left: 18px;
            .item_title {
              color: #262626;
              font-size: 17px;
              font-weight: 700;
              margin-bottom: 6px;
            }
            .item_distance {
              color: #787878;
              font-size: 12px;
              margin-bottom: 6px;
            }
            .labels {
              .label {
                display: inline-block;
                padding: 0px 4px;
                background: rgba(97, 69, 247, 0.15);
                color: #6145f7;
                font-size: 11px;
                margin-right: 4px;
                border-radius: 2px;
              }
            }
          }
        }
        .item_right {
          display: flex;
          .right_item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            img {
              width: 32px;
              height: 32px;
            }
            div {
              font-size: 11px;
              color: rgba(0, 0, 0, 0.5);
              margin-top: 4px;
            }
          }
          .right_item_first {
            margin-right: 18px;
          }
        }
      }
    }
  }

  // 评论列表 start
  .comment-box {
    padding: 20px;
    border-top: 5px solid rgba(0, 0, 0, 0.05);
    border-bottom: 5px solid rgba(0, 0, 0, 0.05);
    /deep/ .van-cell {
      margin: 25px 0px;
      padding: 0px;
    }
    /deep/ .van-cell__title span {
      font-size: 20px;
      font-family: PingFangTC-Medium, PingFangTC;
      font-weight: 500;
      color: rgba(55, 56, 77, 1);
    }
    /deep/ .van-cell__value {
      font-size: 15px;
      font-family: PingFangSC-Light, PingFang SC;
      // font-weight: 300;
      color: #000;
    }
    /deep/ .van-cell:not(:last-child)::after {
      border: 0px;
    }
    /deep/ .van-icon {
      color: #37384d;
      font-size: 16px;
    }
    .comment-list {
      padding: 0px;
    }
    .list-no {
      text-align: left;
      // padding: 30px 0px 0px 0px;
      & > p {
        height: 14px;
        font-size: 15px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: rgba(153, 153, 153, 1);
        line-height: 14px;
      }
    }
    .btn {
      margin-top: 29px;
      width: 100%;
      opacity: 0.95;
      margin-bottom: 24px;
      /deep/ .van-image {
        margin-right: 4px;
        margin-top: -3px;
        img {
          border-radius: 3px;
        }
      }
      /deep/ .van-button {
        width: 100%;
        border: 0px;
        height: 40px;
      }
      /deep/ .van-button span {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        /deep/ .van-icon {
          color: #fff;
          margin-right: 7px;
        }
      }
      /deep/ .van-icon {
        color: #fff;
        margin-right: 7px;
      }
    }
  }
  // 评论列表 end
}
</style>
